import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function UrgencySection() {
  const {
    t
  } = useLanguage();
  const zones = ['Newark', 'Jersey City', 'Elizabeth', 'Paterson', 'Union City'];
  return <section className="bg-brand-primary py-16 md:py-20 text-white relative overflow-hidden" data-id="element-184">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-185"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-186">
        <motion.div className="text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-187">
          <div className="inline-flex items-center justify-center space-x-3 bg-red-500/20 border border-red-400/50 text-white py-2 px-6 rounded-full mb-8" data-id="element-188">
            <AlertTriangle className="w-6 h-6 text-brand-accent" data-id="element-189" />
            <h2 className="text-xl md:text-2xl font-bold uppercase tracking-wide" data-id="element-190">
              {t('urgency.badge')}
            </h2>
          </div>

          <p className="text-xl md:text-2xl font-medium mb-10 leading-relaxed" data-id="element-191">
            {t('urgency.body1')}{' '}
            <span className="font-bold text-brand-accent" data-id="element-192">
              {t('urgency.body2')}
            </span>{' '}
            {t('urgency.body3')}
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 mb-10 border border-white/20" data-id="element-193">
            <div className="flex items-center justify-center mb-4 text-brand-accent" data-id="element-194">
              <MapPin className="w-5 h-5 mr-2" data-id="element-195" />
              <h3 className="text-lg font-semibold uppercase tracking-wider" data-id="element-196">
                {t('urgency.zones')}
              </h3>
            </div>
            <div className="flex flex-wrap justify-center gap-3" data-id="element-197">
              {zones.map((zone, index) => <span key={index} className="bg-white/20 px-4 py-2 rounded-full text-sm md:text-base font-medium" data-id="element-198">
                  {zone}
                </span>)}
            </div>
          </div>

          <p className="text-lg text-gray-200 mb-10 italic" data-id="element-199">
            {t('urgency.warning')}
          </p>

          <a href="https://wa.me/12013540888?text=Hola,%20quiero%20reservar%20mi%20cupo%20antes%20de%20que%20se%20llene%20mi%20zona" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto bg-brand-accent text-brand-navy font-extrabold text-lg md:text-xl py-5 px-8 rounded-lg shadow-[0_0_30px_rgba(251,191,36,0.4)] hover:bg-yellow-300 hover:scale-105 transition-all duration-300 min-h-[60px]" data-id="element-200">
            {t('urgency.cta')}
          </a>
        </motion.div>
      </div>
    </section>;
}